import { Component, ElementRef, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { View } from "ol";
import TileLayer from "ol/layer/Tile";
import { OSM } from "ol/source";
import axios from "src/app/Service/axios";
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import * as XLSX from 'xlsx';
import Map from 'ol/Map';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import * as olProj from 'ol/proj';
import { MapService } from "src/app/Service/map.service";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
declare let $: any;

@Component({
    selector: 'manageInput',
    templateUrl: './manageInputComponent.html',
  })
export class ManageInputComponent implements OnInit {
    constructor(
      private notifyService: NotificationService,
      private router: Router,
      private otherService: OtherService,
      private route: ActivatedRoute,
      private formBuilder: FormBuilder,
      private mapService: MapService,
      private gurdService: GurdServiceService
  
    ) {
  
    }
    domain: any;
  IOUsage:any;
  domainVal: number = -1;
  typeDataVal: number = -1;
  inputsData: any = [];
  fullInputsData: any = [];
  fileName = 'LiveInput.xlsx';
  location: any = [51.3833554, 35.6770113];
  map: any;
  dateTime:Date=new Date();
  ismapCreate: boolean = false;
  inputModel :FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
    iMobileDomain: new FormControl("-1"),
    iIOUsage: new FormControl("-1"),
    strDateTime: new FormControl(""),
    strDate :new Date().valueOf(),
    strTime :new FormControl(`${this.dateTime.getHours()}:${this.dateTime.getMinutes()}`),
  });
  ngOnInit(): void {
    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });
    this.getDomain();
this.getIoData();

  }
  search(){
    var Interval;
    clearInterval(Interval)
    let time=document.getElementById("time")as any;
    this.inputModel.controls["strTime"].setValue(time.value);
    this.inputModel.controls["strDateTime"].setValue("");
    this.getInputsData();
    this.inputsData=[];
    this.fullInputsData=[];
  
    Interval = setInterval(() => {

      this.getInputsData();
    }, 30000);
  }
  getDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`,
      {}
    );
    this.domain = JSON.parse(resp.data);
  }

  getInputsData = async () => {
    var model = this.inputModel.value;
    this.otherService.Showspinner();
    const resp = await axios.post(`IO_GetLastGPSIO`, model);
    this.otherService.nonespinner();
    // this.inputModel.controls["strDate"].setValue("");
    // this.inputModel.controls["strTime"].setValue("");
    JSON.parse(resp.data).forEach((element: any) => {
      this.inputsData.push(element);
      this.fullInputsData.push(element);
    });
    if(this.domainVal!=-1){
      this.inputsData = this.fullInputsData.filter((el: any) => {
        
        if (this.typeDataVal != -1) {
          return this.typeDataVal == el.iIOUsage&&this.domainVal==el.iMobileDomain;
    
        }
        else {
          return this.domainVal==el.iMobileDomain
    
        }
    
      });
    }
    else if(this.typeDataVal!=-1){
      this.inputsData = this.fullInputsData.filter((el: any) => {
          return this.typeDataVal == el.iIOUsage;
    
      });
    }

    if (JSON.parse(resp.data).length == 0) {
      const dateTime = await axios.post(`GetCurrentDateTime`, {});
      this.inputModel.controls["strDateTime"].setValue(dateTime.data);
    }
    else {

      this.inputModel.controls["strDateTime"].setValue(this.inputsData[0].strCurrentDateTime);
    }
    if ($('#show-last-th').is(":checked")) {
      setTimeout(() => {
        var scrollsave = $('#scroll-handel').prop('scrollHeight');
        $('#scroll-handel').animate({ scrollTop: scrollsave }, 1000);

      }, 100);

    }
  }
  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
  newOpenMap() {

    this.map = new Map({
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: 'map-modal',
      layers: [
        new TileLayer({
          source: new OSM({}),
        })
      ],
      view: new View({
        center: olProj.fromLonLat(this.location),
        zoom: 5,
      }),
    }) as any;
  }
  openMap(flat: any, fLon: any, time: any, comment: any) {
    if (!this.ismapCreate) {
      this.newOpenMap();
      this.ismapCreate = true;
    }
    this.mapService.removeMarkerById("marker", this.map);
    var marker = this.mapService.createMarker([fLon, flat],
      '../../assets/Img/marker5.png',
      `marker`,
      ``,
      {
        html: `
        <p class='text-dark mb-0 f14'>${comment}</p>
        <p class='text-dark mb-0 f12'>${time}</p>

        `,
      });
    this.map.addLayer(marker);
    this.mapService.fitMap([{ fLon: fLon, fLat: flat }], this.map);
    setTimeout(() => {
      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }
        setTimeout(() => {
          var el = this.mapService.mapPointerMove(
            this.map.getEventPixel(e.originalEvent),
            this.map
          );
          this.showData(el);

        }, 50);
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 500);
  }
  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        tooltip
          .attr(
            'data-bs-original-title',
            item.featureLayer.feature.get('data').html
          )
          .tooltip('show');
      }
    } else {
      tooltip.tooltip('hide');
    }
  }
  changeDomain(e: any) {
    this.domainVal = e.value;
    this.inputsData = this.fullInputsData.filter((el: any) => {
      if (this.typeDataVal != -1) {
        return e.value == el.iMobileDomain&&this.typeDataVal==el.iIOUsage;

      }
      else {
        return e.value == el.iMobileDomain;

      }

    });
  }
  changeTypeData(e: any) {
    this.typeDataVal = e.value;

    this.inputsData = this.fullInputsData.filter((el: any) => {

      if (this.domainVal != -1) {
        return e.value == el.iIOUsage&&this.domainVal==el.iMobileDomain;

      }
      else {
        return e.value == el.iIOUsage;

      }

    });
  }
  getIoData=async()=>{
    // var model = {
    //   strSession: `${localStorage.getItem('Session')}`,
    //   iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    // };
    const resp=await axios.post(`IO_GetIOUsage`);
    this.IOUsage=JSON.parse(resp.data);
  }
}